import { lazy } from 'react';

// Lazy load pages for better performance
const Home = lazy(() => import('../Pages/Home'));
const About = lazy(() => import('../Pages/About'));
const ServicesList = lazy(() => import('../Pages/Services/ServicesList'));
const ServiceDetail = lazy(() => import('../Pages/Services/ServiceDetail'));
const Gallery = lazy(() => import('../Pages/Gallery'));
const Videos = lazy(() => import('../Pages/Videos'));
const Media = lazy(() => import('../Pages/Media'));
const BlogList = lazy(() => import('../Pages/Blog/BlogList'));
const BlogDetail = lazy(() => import('../Pages/Blog/BlogDetail'));
const Testimonials = lazy(() => import('../Pages/Testimonials'));
const Contact = lazy(() => import('../Pages/Contact'));
const Appointment = lazy(() => import('../Pages/Appointment'));
const ARTIFICIAL = lazy(() => import('../Pages/ARTIFICIAL/ARTIFICIAL'));
const Blastocyst = lazy(() => import('../Pages/Blastocyst/Blastocyst'));
const infertilete = lazy(() => import('../Pages/Infertility-Treatment/infertilete'));
const Oocyte = lazy(() => import('../Pages/Oocyte/Oocyte'));
const Fertility = lazy(() => import('../Pages/Fertility/fertility'));
const Donor = lazy(() => import('../Pages/Donor/Donor'));
const Testicular = lazy(() => import('../Pages/testicular/Testicular'));
const IVF = lazy(() => import('../Pages/IVF/IVF'));
const IMSI = lazy(() => import('../Pages/IMSI/IMSI'));
const DonorSperm = lazy(() => import('../Pages/Donor-sperm/Donor-sperm'));
const Micro = lazy(() => import('../Pages/Micro/Micro'));
const ICSI = lazy(() => import('../Pages/ICSI/ICSI'));
const Assisted = lazy(() => import('../Pages/Assisted/Assisted'));
const Surrogacy = lazy(() => import('../Pages/Surrogacy/Surrogacy'));
const PGT = lazy(() => import('../Pages/PGT/PGT'));

export const routes = [
  { path: '/', element: Home },
  { path: '/home', element: Home },
  { path: '/about', element: About },
  { path: '/services', element: ServicesList },
  { path: '/services/:slug', element: ServiceDetail },
  { path: '/gallery', element: Gallery },
  { path: '/videos', element: Videos },
  { path: '/media', element: Media },
  { path: '/blog', element: BlogList },
  { path: '/blog/:slug', element: BlogDetail },
  { path: '/testimonials', element: Testimonials },
  { path: '/contact', element: Contact },
  { path: '/appointment', element: Appointment },


  { path: '/artificial-insemination-iui', element: ARTIFICIAL },
    { path: '/blastocyst-transfer', element: Blastocyst },
  { path: '/oocyte-and-embryo-freezing', element: Oocyte },
  { path: '/fertility-enhancing-laparoscopy-and-hysteroscopy', element: Fertility },
  { path: '/donor-egg-ivf', element: Donor },
  { path: '/testicular-aspiration-or-tesa', element: Testicular },
  { path: '/ivf-treatment-in-delhi', element: IVF },
  { path: '/imsi', element: IMSI },
  { path: '/donor-sperm-ivf', element: DonorSperm },
  { path: '/microtesa', element: Micro },
  { path: '/icsi', element: ICSI },
  { path: '/assisted-hatching', element: Assisted },
  { path: '/surrogacy', element: Surrogacy },
  { path: '/pre-genetic-screening-and-diagnosis', element: PGT },
  {path : '/infertility-treatment-in-delhi' , element :infertilete}
];